import { NewComponent } from "../components";
import { connect } from "react-redux";
import {
    GetDataNewPlanHandleAction, SetDataNewPlanHandleAction,
    ClearDataNewPlanHandleAction, UploadFilePlanHandleAction, DownloadFileAction, GetDataLinkApiAction
    , GetDataLinkApibyidAction, GetDataEmailAzureAction, GetDataValidateDateAction, GetDataPlanByPassAction
} from "../actions";

const mapStateToProps = state => {
    return {
        ...state,
        DataNew: state.allPlanHandleReducers.newReducer.DataNew,
        DataFile: state.allPlanHandleReducers.fileReducer.DataFile,
        DataLinkApi: state.allPlanHandleReducers.DataLinkApiReducer.DataLinkApi,
        DataLinkApibyid: state.allPlanHandleReducers.DataLinkApibyidReducer.DataLinkApibyid,
        isResult: state.allPlanHandleReducers.isResultReducer.isResult,
        DataEmailAzure: state.allPlanHandleReducers.DataEmailAzureByNameReducer.DataEmailAzure,
        DataValidate: state.allPlanHandleReducers.DataValidateDateReducer.DataValidate,
        DataPlan: state.allPlanHandleReducers.DataPlanByPassReducer.DataPlan
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetDataNew: (ID, PlanID) => {
            dispatch(GetDataNewPlanHandleAction(ID, PlanID));
        },
        SetDataNew: (DataNew) => {
            dispatch(SetDataNewPlanHandleAction(DataNew));
        },
        UploadFile: (File, Index) => {
            dispatch(UploadFilePlanHandleAction(File, Index));
        },
        ClearDataNew: (DataNew) => {
            dispatch(ClearDataNewPlanHandleAction(DataNew));
        },
        DownloadFile: (value) => {
            dispatch(DownloadFileAction(value));
        },
        GetDataLinkApi: (DataLinkApi) => {
            dispatch(GetDataLinkApiAction(DataLinkApi));
        },
        GetDataLinkApibyid: (DataLinkApibyid) => {
            dispatch(GetDataLinkApibyidAction(DataLinkApibyid));
        },
        GetDataEmailAzureByName: (DataEmailAzure) => { 
            dispatch(GetDataEmailAzureAction(DataEmailAzure)); 
        },
        GetValidateDate: (DataValidate) =>{
            dispatch(GetDataValidateDateAction(DataValidate))
        },
        GetDataPlanByPass: () =>{
            dispatch(GetDataPlanByPassAction())
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewComponent);